<template>
  <div>
    <div class="trade-order-block" v-show="wccsIdShow">
      <div class="block-title">补充信息</div>
      <div class="block-content">
        <el-row class="content-row" style="line-height: 30px">
          <!-- WCCSID -->
          <el-col :span="4">WCCSID</el-col>
          <el-col :span="7">
            <el-input v-model="formData.wccsId" type="text" size="small" placeholder="请填写WCCSID" />
          </el-col>
        </el-row>
        <el-row class="supplement-btn">
          <el-button size="small" @click="resetData">重置</el-button>
          <el-button class="btn-red" size="small" @click="submitData">提交</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'

export default {
  name: 'order-supplement-info',
  data () {
    return {
      formData: {
        wccsId: '',
        applyId: ''
      },

      wccsIdShow: false,

      tradeApplyOrderVO: '',
      tradeApplyInfoVO: '',
      tradeApplyBaseVO: '',
      basePocInfo: {},
      tradeApplyExecCooler: null,
      userInfo: ''
    }
  },
  created () {

  },
  methods: {
    setShowInfo (info, user) {
      this.wccsIdShow = false

      this.tradeApplyOrderVO = info
      this.tradeApplyInfoVO = info.tradeApplyInfoVO
      this.tradeApplyBaseVO = info.tradeApplyBaseVO
      this.basePocInfo = info.basePocInfo
      this.tradeApplyExecCooler = info.tradeApplyExecCooler
      this.userInfo = user

      this.formData.applyId = this.tradeApplyOrderVO.applyId
      if (this.tradeApplyInfoVO.acceptanceStatus === '410') {
        this.formData.wccsId = this.basePocInfo.wccsId || ''
      }

      // wccsid
      if (this.tradeApplyExecCooler) {
        if (!this.basePocInfo.wccsId) {
          this.wccsIdShow = true
        }
      }
    },

    // 重置
    resetData () {
      this.formData.wccsId = ''
    },

    // 提交
    submitData () {
      if (!this.formData.wccsId) {
        return
      }

      if (this.tradeApplyInfoVO.acceptanceStatus !== '410') {
        if (this.tradeApplyExecCooler) {
          this.$store.dispatch('addCoolerInfo', this.formData).then(res => {
            if (res.data.resultCode === '0') {
              this.$message.success('补充信息成功')
              this.$emit('supplementSucc')
            }
          })
        } else {
          if (this.tradeApplyOrderVO.applyType === '03') {
            this.$store.dispatch('addIspInfo', this.formData).then(res => {
              if (res.data.resultCode === '0') {
                this.$message.success('补充信息成功')
                this.$emit('supplementSucc')
              }
            })
          } else {
            this.$store.dispatch('addInfo', this.formData).then(res => {
              if (res.data.resultCode === '0') {
                this.$message.success('补充信息成功')
                this.$emit('supplementSucc')
              }
            })
          }
        }
      } else {
        let data = {
          applyId: this.formData.applyId,
          approvalResult: '01',
          approvalType: '03',
          processClientId: this.userInfo.clientId,
          processClientName: this.userInfo.clientName,
          wccsId: this.formData.wccsId
        }
        if (this.tradeApplyOrderVO.applyType === '03') {
          this.$store.dispatch('handleIspApprove', data).then(res => {
            if (res.data.resultCode === '0') {
              this.$message.success('补充信息成功')
              this.$emit('supplementSucc')
            }
          })
        } else {
          this.$store.dispatch('handleApprove', data).then(res => {
            if (res.data.resultCode === '0') {
              this.$message.success('补充信息成功')
              this.$emit('supplementSucc')
            }
          })
        }
      }
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  box-sizing: border-box;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  height: 110px;
  width: 110px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 110px;
  height: 110px;
  line-height: 110px;
  text-align: center;
}
.avatar {
  width: 110px;
  height: 110px;
  display: block;
  border-radius: 6px;
  object-fit: cover;
  cursor: pointer;
}

.el-icon-error {
  position: absolute;
  left: 115px;
  top: -10px;
  font-size: 22px;
  color: #aaa;
  cursor: pointer;
}

.supplement-btn {
  margin-top: 10px;
  padding-left: 400px;
}
</style>
